module.exports = __webpack_public_path__ + "static/media/diretor.f813e757.jpg";